module.exports = __webpack_public_path__ + "img/1515055281.02204cb0.jpg";